<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title>
				<button type="button" class="btn-flat-icon--dark" @click="open = false">
					<v-icon medium>fal fa-times</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="pt-5 pl-4 pr-4 event-page__modal-card-text text-xs-center" v-if="getUserObject">
				<div>
					<p class="event-page-content">
						Please confirm you are not interested in this member attending your event.<br><br>
						Please note that they will receive a message letting them know that their request was not approved for this event, but that we recommend they try again for the next one.
						<br><br>Please also be reminded that discrimination is not permitted, per our Discrimination Policy. If you have had a poor experience with this guest in the past, please Report this member by submitting a note via the member's profile page. If you wish to ask this member a question before approving their request you may do so from their profile page. To ignore this request and remove this user from your attendee list, please click the button below
					</p>
					<v-btn flat @click="open = false">Go back</v-btn>
					<v-btn flat class="error" @click="denyGuest(getUserObject.uuid)">Deny</v-btn>
				</div>
				<div>
					<img class="event-page-flat-logo mb-4 mt-4" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
export default {
	name: 'denyGuestConfirmationModal',
	methods: {
		...mapActions(['setModalOpen', 'setEventProp']),
		denyGuest(guestUUID) {
			axios
				.get(
					'/api/v1/event/' + this.event.slug + '/deny-guest/' + guestUUID + '/'
				)
				.then(response => {
					let userObj = this.event.pending_attendees.find(
						obj => obj.uuid === guestUUID
					)
					let newArray = this.event.pending_attendees.slice(0)
					newArray.splice(this.event.pending_attendees.indexOf(userObj), 1)
					this.setEventProp({
						uuid: this.event.uuid,
						prop: 'pending_attendees',
						value: newArray
					})
					this.setEventProp({
						uuid: this.event.uuid,
						prop: 'denied_attendees',
						value: this.event.denied_attendees.concat(userObj)
					})
					this.setModalOpen({
						prop: 'denyGuestConfirmationModal',
						value: false
					})
				})
				.catch(error => {
					console.error(error)
				})
		}
	},
	computed: {
		...mapGetters(['getModalProp', 'getAllEvents']),
		getUserObject() {
			let attendees = this.event.attendees.concat(
				this.event.pending_attendees,
				this.event.denied_attendees
			)
			let userObj = attendees.find(obj => obj.uuid === this.guestModalIndex)
			return userObj
		},
		open: {
			get() {
				return this.getModalProp('denyGuestConfirmationModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'denyGuestConfirmationModal', value: val })
			}
		},
		event() {
			return this.getModalProp('eventModalEvent')
		},
		guestModalIndex() {
			return this.getModalProp('eventGuestModalIndex')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
